<template>
  <div>
    <div v-html="html"></div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      html: ''
    }
  },
  created() {
    const _ = this
    window.addEventListener('message', function (event) {
    //   console.log('接收到参数', event.data); // 输出: {param1: 'value1', param2: 'value2'}
      const message = typeof event.data === 'string' ? JSON.parse(event.data) : event.data;
      if (message.type === 'alipay') {
        console.log(message)
        _.init(message.data)
      }

    }, false);
  },
  mounted() {
    let alipay = localStorage.getItem("alipay");
    console.log('aasdadsas')
    if (alipay) {
      localStorage.removeItem("alipay");
      setTimeout(() => {
        console.log('发送消息')
        window.parent.postMessage(JSON.stringify({
            action: 'alipayScuccess',
         }), "*");
      }, 1000)
    }
  },
  methods: {
    init(e) {
      console.log(e)
      this.html = e
      this.$nextTick(() => {
        localStorage.setItem('alipay', '1')
        document.forms[0].submit()   //渲染支付宝支付页面
      })
    }
  }
}
</script>